import classNames from "classnames";
import React, { JSX } from "react";

import { Typography } from "../typography";
import css from "./tag.module.scss";

type TagProps = {
  text: number | string;
  highlight: boolean;
  variant?: "default" | "error";
};

export const Tag = ({ text, variant = "default", highlight = true }: TagProps): JSX.Element => (
  <Typography
    variant="labelButton"
    className={classNames(css.tag, css[variant], { [css.highlight]: highlight })}
  >
    {text}
  </Typography>
);
